export default "__VITE_ASSET__DOY4QkSG__"